import { createReducer } from '../utils/misc';

import {
  REGISTER_COUPON,
} from '../constants/index';

const initialState = {
  fetching: true,
  data: null
};

export default createReducer(initialState, {
  ['FETCH_COUPONS_REQUEST']: (state) => {
    return {
      ...state, 
      fetching: true,
    }
  },
  ['FETCH_COUPONS_RECEIVE']: (state, payload) => {
    return {
      ...state, 
      fetching: false,
      data: payload.coupons,
    }
  },
  [REGISTER_COUPON]: (state, payload) => {
    return {
      ...state,
      coupons: payload.coupons,
    }
  }
});
